export default {
  getSelectedOffer: state => {
    return state.selectedOffer
  }
}
